import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  DELETE_BONUS_COUPON,
  SHOW_BONUS_COUPON_DIALOG,
} from './actionTypes'
import * as services from './services'
import * as actions from './actions'
export default {
  
   *[FETCH_LIST]({ payload }) { // 获取分组列表数据
        const { params } = payload
        yield actions.toggleLoading()
        const { data, total } = yield call(services.fetchList, params)
        yield put(actions.listFetched({ data, total }))
        yield actions.toggleLoading()
   },
  *[SHOW_BONUS_COUPON_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('BONUS_COUPON_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[DELETE_BONUS_COUPON]({ payload }) {
    const { id } = payload
    yield call(services.deleteBonusCoupon, id)
    if(payload.onSuccess){
        payload.onSuccess()
    }
  },

}
